module.exports = __webpack_public_path__ + "static/img/introduce1.830946b0.png";